import { useState } from "react";

const C = {
  red: "#e94560", gold: "#f5a623", teal: "#64ffda",
  purple: "#E879F9", green: "#34D399", blue: "#3B82F6",
  ig: "#E1306C", tt: "#69C9D0", yt: "#FF0000",
  dark: "#070b14", card: "rgba(255,255,255,0.03)", border: "#151f2e",
};

const psychologyLayers = [
  { icon: "🧠", title: "الخوف من الغش", desc: "المستهلك العراقي يشك في جودة اللحوم المجمدة", trigger: "هل هذا حلال؟ هل هو طازج؟ هل نسبة اللحم حقيقية؟", solution: "فيديوهات المصنع + شهادات الجودة + محتوى UGC من شفات أو أشخاص عاديين يجربون المنتج على الطبيعي", color: "#FF6B6B" },
  { icon: "❤️", title: "الانتماء والهوية", desc: "الطعام العراقي مرتبط بالذاكرة العاطفية والعائلة", trigger: "هذا طعم البيت، طعم أمي، طعم اللمة", solution: "محتوى عائلي دافئ + ربط المنتج بلحظات اجتماعية عراقية حقيقية", color: "#FF8E53" },
  { icon: "⏱️", title: "ضغط الوقت", desc: "المرأة العاملة تبحث عن حل سريع بدون تنازل عن الجودة", trigger: "ما عندي وقت أطبخ بس أريد أطعم عيلتي زين", solution: 'إبراز سرعة التحضير "جاهز بـ 10 دقائق" — ريلز عفوي بمطبخ حقيقي', color: "#A855F7" },
  { icon: "💰", title: "الحساسية السعرية", desc: "المستهلك العراقي يقارن السعر بالكمية والجودة", trigger: "يسوى؟ غالي؟ أوفر من السوق؟", solution: "مقارنات قيمة لا سعر + عرض 3+1 كمحرك رئيسي للقرار", color: "#3B82F6" },
  { icon: "👥", title: "الدليل الاجتماعي", desc: "العراقي يثق بتجربة الغير أكثر من الإعلان المباشر", trigger: "شلون يقولون؟ مجرب؟ الشيف الفلاني يستخدمه؟", solution: "شهادات زبائن حقيقية + شفات موثوقين ينطون وصفات + محتوى UGC عفوي", color: "#10B981" },
  { icon: "🏆", title: "الفخر المحلي", desc: "موجة دعم المنتج العراقي في تصاعد مستمر", trigger: "صنع في العراق = دعم الاقتصاد = فخر وطني", solution: '"منتج عراقي أصيل من البصرة" كرسالة تسويقية محورية', color: "#F59E0B" },
  { icon: "🎰", title: "الإثارة والمكافأة الآنية", desc: "عجلة الحظ تُشبع الحاجة النفسية للإثارة والمكافأة غير المتوقعة", trigger: "ممكن أربح؟ شنو ربح الثاني؟ خليني أجرب مرة ثانية!", solution: "محتوى يُظهر فرحة الفائزين + شهادات حقيقية + الكود على المنتج = فضول يحفز الشراء", color: "#E879F9" },
  { icon: "🚗", title: "حلم الجائزة الكبرى", desc: "السيارة تمثل حلماً حقيقياً لشريحة واسعة من العراقيين", trigger: "بس بشراء منتج ممكن أربح سيارة؟ هذا جدي؟", solution: "شفافية تامة في آلية السحب + فيديو تسليم السيارة = أقوى إعلان مجاني في تاريخ الشركة", color: "#F59E0B" },
  { icon: "🎁", title: "نفسية اشترِ 3 واربح 4", desc: "الزبون يشعر بالذكاء حين يحصل على قيمة مجانية", trigger: "الرابع مجاني؟ يعني أوفر بكثير، لازم أشتري الآن!", solution: "أبرز المنتج الرابع بالاسم والصورة — الغموض يقتل قرار الشراء", color: "#34D399" },
];

const gamificationFeatures = [
  {
    id: "wheel", icon: "🎰", title: "عجلة الحظ", subtitle: "كود على المنتج",
    color: "#E879F9", gradient: "linear-gradient(135deg, #7c3aed, #e879f9)",
    psycho: "الدوبامين + الفضول + FOMO",
    psychoDetail: "الكود على المنتج يحوّل كل عبوة إلى لحظة إثارة. الزبون لا يعرف إذا سيربح حتى يفتح — هذا الغموض الإيجابي هو أقوى محرك للشراء المتكرر.",
    platforms: [
      { name: "📸 إنستغرام", tactics: ["Reel: شخص يفتح المنتج ويجد الكود ثم يدور العجلة — ردة فعل حقيقية بدون تمثيل", "Stories يومية: 'اليوم ربح X شخص — أنت التالي؟' + رابط التطبيق", "Highlight مخصص: أرشيف جميع الفائزين + صور مكافآتهم", "Story Poll: 'شنو تتمنى تربح؟' لفهم الجمهور وزيادة التفاعل"] },
      { name: "🎵 تيك توك", tactics: ["Hook: 'اشتريت فلافل وصار لي شي ما توقعته' — الفضول يجبر على المشاهدة", "فيديو Screen Recording: دوران العجلة في التطبيق + ردة فعل صادقة", "UGC تحدي: 'شوف شنو ربحت من كودك' — المستخدمون يصورون ويشاركون", "Duet مع فيديوهات الفائزين — انتشار عضوي مضاعف"] },
      { name: "📺 يوتيوب", tactics: ["Short: 'فتحت عبوة وربحت!' — 30 ثانية تلخص التجربة", "فيديو تعليمي: كيف تعمل عجلة الحظ وكيف تفوز؟", "Playlist مخصص: تجميع فيديوهات الفائزين"] },
    ],
    mistakes: [
      { m: "عدم نشر أسماء الفائزين علناً", fix: "الشفافية = ثقة = مزيد من الشراء" },
      { m: "لا يوجد محتوى يشرح آلية الكود والعجلة", fix: "فيديو تعليمي واحد يُزيل الشك ويحفز التجربة" },
      { m: "الترويج غير منتظم", fix: "جدول أسبوعي: فائز كل أسبوع = محتوى منتظم يبني التوقع" },
    ],
  },
  {
    id: "car", icon: "🚗", title: "السحب على السيارة", subtitle: "الجائزة الكبرى",
    color: "#F59E0B", gradient: "linear-gradient(135deg, #b45309, #f59e0b)",
    psycho: "حلم التغيير + الطموح + FOMO + الدليل الاجتماعي",
    psychoDetail: "السيارة في العقل العراقي = ارتقاء اجتماعي وتحقيق حلم. ربط شراء المنتج اليومي بهذا الحلم هو أقوى محرك نفسي للقرار الشرائي.",
    platforms: [
      { name: "📸 إنستغرام", tactics: ["Story Series أسبوعية: جولة حول جائزة السيارة + تعداد أيام المتبقية", "Reel مونتاج: اشترِ ← ابحث عن الكود ← دوّر العجلة ← ادخل السحب", "Highlight: كل شيء عن السحب (الشروط، المشاركين، موعد الإعلان)", "Countdown Sticker: يُنبه المتابعين تلقائياً لحظة الإعلان"] },
      { name: "🎵 تيك توك", tactics: ["Hook: 'هذا الشخص اشترى كبة وربح سيارة — هذا حصل فعلاً'", "فيديو تسليم السيارة: جودة سينمائية — سيُشارَك آلاف المرات", "Interview مع الفائز: ردة فعله الحقيقية + قصته الكاملة", "Behind the Scenes: كيف تمت عملية السحب بشفافية أمام الكاميرا"] },
      { name: "📺 يوتيوب", tactics: ["فيديو كامل لتسليم السيارة: من الإعلان حتى تسليم المفتاح", "Documentary قصير: رحلة الفائز من الشراء حتى الفوز", "Live السحب: الشفافية الكاملة أمام آلاف المشاهدين"] },
    ],
    mistakes: [
      { m: "عدم توثيق عملية السحب بشفافية", fix: "Live السحب = الدليل الأقوى على المصداقية" },
      { m: "غياب صورة السيارة من المنشورات", fix: "السيارة = المحفز البصري الأول — يجب أن تكون دائماً حاضرة" },
      { m: "لا يُحدَّث عدد المشاركين", fix: "عداد متزايد يُنشئ ضغط FOMO إيجابي يحفز الشراء" },
    ],
  },
  {
    id: "bundle", icon: "🎁", title: "اشترِ 3 واربح 4", subtitle: "Buy 3 Get 1 Free",
    color: "#34D399", gradient: "linear-gradient(135deg, #065f46, #34d399)",
    psycho: "الذكاء الاقتصادي + التحكم + تجنب الخسارة",
    psychoDetail: "الزبون يشعر أنه 'ذكي' حين يحصل على منتج مجاناً. مبدأ Anchoring يجعله يقارن سعر 4 بسعر 3 ويرى التوفير بوضوح — قرار الشراء يصبح سهلاً.",
    platforms: [
      { name: "📸 إنستغرام", tactics: ["Reel: يد تضع 3 منتجات في السلة ثم الرابع يظهر تلقائياً بكلمة مجاناً", "Story تفاعلية: صوّت — أي 3 منتجات تختار وماذا تريد رابعاً؟", "Countdown Story: 'العرض ينتهي بعد X ساعة' لخلق urgency حقيقي", "Comparison بصري: سعر 4 منتجات عادي مقابل سعرها بالعرض"] },
      { name: "🎵 تيك توك", tactics: ["Hook: 'اشترينا من التطبيق وحصلنا على منتج رابع مجاناً — هذا حقيقي'", "Unboxing: شخص يفتح طلبه ويفاجأ بالمنتج الرابع داخل الطلب", "Tutorial سريع: كيف تختار 3 منتجات وتضيفهم للسلة في التطبيق", "POV: أنا بالسوبرماركت أشتري 3 أو من التطبيق وأربح 4"] },
      { name: "📺 يوتيوب", tactics: ["Short: مقارنة مرئية — الشراء العادي مقابل الشراء من التطبيق والفرق", "فيديو طبخ كامل بالمنتجات الأربعة — محتوى قيّم يبيع بدون إعلان مباشر"] },
    ],
    mistakes: [
      { m: "تصميم لا يوضح العرض في 3 ثوان", fix: "قاعدة 3 ثوان: المتابع يفهم العرض من نظرة واحدة أو يتجاوزه" },
      { m: "لا يُذكر المنتج الرابع بالاسم والصورة", fix: "الغموض يقتل قرار الشراء — حدد الهدية بوضوح تام" },
      { m: "العرض دائم بدون deadline", fix: "'العرض حتى نهاية الأسبوع' — الضغط الزمني يُسرّع القرار" },
    ],
  },
];

const funnelSteps = [
  { step: "01", label: "الوعي", action: "يرى فيديو عفوي أو ريلز مثير للمنتج أو الجائزة", channel: "تيك توك / إنستغرام", color: "#E879F9" },
  { step: "02", label: "الاهتمام", action: "يتفاعل: كومنت، حفظ، أو سؤال 'كيف أشارك؟'", channel: "تعليقات + DM", color: "#A855F7" },
  { step: "03", label: "القرار", action: "يضغط رابط التطبيق في Bio أو Story", channel: "Bio Link / Story", color: "#3B82F6" },
  { step: "04", label: "الشراء", action: "يختار 3 منتجات ليحصل على الرابع مجاناً", channel: "التطبيق", color: "#10B981" },
  { step: "05", label: "المكافأة", action: "يجد الكود على المنتج ويدور عجلة الحظ ويدخل سحب السيارة", channel: "التطبيق", color: "#34D399" },
  { step: "06", label: "المشاركة", action: "يصور تجربته ويشاركها = UGC مجاني وانتشار عضوي", channel: "كل المنصات", color: "#F59E0B" },
];

const offerItems = [
  { icon: "🎬", title: "6 فيديوهات شهرياً", desc: "فيديوهات احترافية تبيع الشعور وتحفز الشراء — تشمل وصفات، UGC، عجلة الحظ، والعروض" },
  { icon: "📢", title: "إدارة الترويج الكاملة", desc: "حملات إعلانية مدفوعة مُصممة لتحقيق أعلى عائد — استهداف دقيق لكل شريحة في البصرة والعراق" },
  { icon: "✍️", title: "إدارة المحتوى", desc: "خطة محتوى شهرية كاملة: أفكار، سكريبت، توجيه تصوير، ومراجعة — محتوى يحقق نتائج لا مجرد نشر روتيني" },
  { icon: "📅", title: "إدارة النشر الاحترافية", desc: "هاشتاقات مدروسة + كابشنات تناسب خوارزمية كل منصة + SEO + توقيت نشر مثالي + ردود تبني مجتمعاً" },
  { icon: "🎯", title: "استهداف دقيق لكل فئة", desc: "تحليل Audience Insights + بناء Custom & Lookalike Audiences + Retargeting لمن زار التطبيق ولم يشترِ" },
  { icon: "📱", title: "تسويق التطبيق استراتيجياً", desc: "بنرات جذابة + إشعارات Push مدروسة + حملات App Install + ربط كل محتوى بتحميل التطبيق" },
  { icon: "🎨", title: "6-10 تصاميم احترافية شهرياً", desc: "تصاميم تبيع الشعور وتعكس هوية جيكور — هوية بصرية محكمة تناسب البراند وتحقق نتائج" },
  { icon: "📊", title: "تقارير أداء دورية", desc: "تقرير أسبوعي مختصر + تقرير شهري تفصيلي يشمل: مقارنة المنافسين، KPIs، والتعديلات المطلوبة" },
  { icon: "🗺️", title: "خطة تسويق لكل المنصات", desc: "استراتيجية مخصصة لإنستغرام + تيك توك + يوتيوب مبنية على بيانات وليس تخمين" },
  { icon: "💡", title: "استشارات تسويقية مجانية", desc: "استشارات غير محدودة طوال الشهر — أي قرار تسويقي، أي فكرة، أي تحدي — أنا معك" },
];

// ---- Demographics Chart Component ----
function DemographicsChart() {
  const ages = ["0-2","3-9","10-19","20-29","30-39","40-49","50-59","60-69"];
  const jekor  = [1,8,8,46,30,5,1,1];
  const sama   = [2,5,11,40,33,5,2,2];
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
      {[
        { name: "جيكور", data: jekor, color: C.teal, gender: "67% ذكور / 33% إناث" },
        { name: "سما كربلاء", data: sama, color: "#FF6B6B", gender: "87% ذكور / 13% إناث" },
      ].map((brand, bi) => (
        <div key={bi} style={{ background: `${brand.color}08`, border: `1px solid ${brand.color}25`, borderRadius: 14, padding: 16 }}>
          <div style={{ fontWeight: 800, color: brand.color, fontSize: 14, marginBottom: 4 }}>{brand.name}</div>
          <div style={{ fontSize: 11, color: "#8892b0", marginBottom: 14 }}>{brand.gender}</div>
          {ages.map((age, i) => (
            <div key={i} style={{ marginBottom: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                <span style={{ fontSize: 11, color: "#8892b0" }}>{age}</span>
                <span style={{ fontSize: 11, fontWeight: 700, color: brand.color }}>{brand.data[i]}%</span>
              </div>
              <div style={{ height: 6, background: "rgba(255,255,255,0.06)", borderRadius: 3, overflow: "hidden" }}>
                <div style={{ height: "100%", width: `${brand.data[i]}%`, background: brand.color, borderRadius: 3, transition: "width 1s ease" }} />
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

// ---- Growth Chart ----
function GrowthChart() {
  const points = [
    { label: "11", jekor: -2, sama: 32 },
    { label: "11.5", jekor: -3, sama: 25 },
    { label: "12", jekor: -1, sama: 20 },
    { label: "12.5", jekor: -2, sama: 15 },
    { label: "13", jekor: -4, sama: 12 },
    { label: "13.5", jekor: -2, sama: 8 },
    { label: "14", jekor: 0, sama: 5 },
    { label: "14.5", jekor: 40, sama: 4 },
    { label: "15", jekor: 152, sama: 3 },
  ];
  const W = 500, H = 180, pad = 40;
  const minV = -30, maxV = 180, rangeV = maxV - minV;
  const toY = v => pad + (1 - (v - minV) / rangeV) * (H - pad * 2);
  const toX = i => pad + (i / (points.length - 1)) * (W - pad * 2);
  const polyline = (data, key) => points.map((p, i) => `${toX(i)},${toY(p[key])}`).join(" ");
  return (
    <div style={{ overflowX: "auto" }}>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", maxWidth: W, display: "block" }}>
        <line x1={pad} y1={toY(0)} x2={W - pad} y2={toY(0)} stroke="rgba(255,255,255,0.15)" strokeWidth="1" strokeDasharray="4,4" />
        <polyline fill="none" stroke={C.teal} strokeWidth="2.5" points={polyline(points, "jekor")} />
        <polyline fill="none" stroke="#FF6B6B" strokeWidth="2" strokeDasharray="6,3" points={polyline(points, "sama")} />
        {points.map((p, i) => (
          <circle key={i} cx={toX(i)} cy={toY(p.jekor)} r="3" fill={C.teal} />
        ))}
        {points.filter((_, i) => i % 2 === 0).map((p, i) => (
          <text key={i} x={toX(i * 2)} y={H - 6} textAnchor="middle" fontSize="9" fill="#8892b0">{p.label}</text>
        ))}
        <text x={W - pad + 4} y={toY(points[points.length-1].jekor) + 4} fontSize="9" fill={C.teal}>@jekorfood</text>
        <text x={W - pad + 4} y={toY(points[points.length-1].sama) + 4} fontSize="9" fill="#FF6B6B">@sama</text>
      </svg>
      <div style={{ display: "flex", gap: 20, justifyContent: "center", marginTop: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: C.teal }}><div style={{ width: 20, height: 3, background: C.teal, borderRadius: 2 }} /> جيكور (UGC → انفجار)</div>
        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "#FF6B6B" }}><div style={{ width: 20, height: 3, background: "#FF6B6B", borderRadius: 2, borderTop: "1px dashed #FF6B6B" }} /> سما كربلاء (تراجع)</div>
      </div>
    </div>
  );
}

export default function App() {
  const [activeTab, setActiveTab] = useState("competitor");
  const [activeFeature, setActiveFeature] = useState("wheel");
  const [activePlatformTactic, setActivePlatformTactic] = useState(0);
  const [activePlatform, setActivePlatform] = useState("tiktok");
  const [expandedProb, setExpandedProb] = useState(null);
  const [expandedPsycho, setExpandedPsycho] = useState(null);
  const [activeDemo, setActiveDemo] = useState("age");

  const currentFeature = gamificationFeatures.find(f => f.id === activeFeature);

  const ttMetrics = [
    { label: "متابعو جيكور", val: "7.6K", note: "أقل من إمكاناتها بكثير", color: C.teal },
    { label: "متابعو سما كربلاء", val: "26.5K", note: "تفوق بالمتابعين", color: "#FF6B6B" },
    { label: "مشاهدات جيكور (إجمالي)", val: "37.3M", note: "🔥 أعلى من سما!", color: C.gold },
    { label: "مشاهدات سما (إجمالي)", val: "25.5M", note: "أقل رغم أكثر متابعين", color: "#FF6B6B" },
    { label: "Engagement جيكور", val: "0.2%", note: "أقل من المعيار 1%+", color: C.teal },
    { label: "Engagement سما", val: "1.2%", note: "6 أضعاف جيكور", color: "#FF6B6B" },
    { label: "متوسط مشاهدة/فيديو (جيكور)", val: "400.7K", note: "🔥 3x أعلى من سما!", color: C.teal },
    { label: "متوسط مشاهدة/فيديو (سما)", val: "130.8K", note: "أقل رغم تفاعل أعلى", color: "#FF6B6B" },
  ];

  const ttProblems = [
    { prob: "لا يوجد محتوى مخصص للمنصة — نفس محتوى الإنستغرام", impact: "عالي", fix: "تيك توك لها لغة خاصة: عفوية، سريعة، مباشرة، تبدأ بصدمة أو سؤال مثير للتفكير" },
    { prob: "غياب المحتوى العفوي بعيداً عن التصاميم والفيديوهات الجامدة", impact: "عالي", fix: "الكاميرا في المطبخ الحقيقي + صوت القلي + ردة فعل صادقة = محتوى ينتشر لوحده" },
    { prob: "الترند لا يُوظَّف بكفاءة وقرب من الجمهور", impact: "عالي", fix: "تابع trending sounds عراقية أسبوعياً وطوّعها لمنتجات جيكور بذكاء وعفوية" },
    { prob: "لا يوجد محتوى UGC أو تحديات تفاعلية", impact: "متوسط", fix: "تحدي 'صوّر وصفتك بمنتجات جيكور' = محتوى مجاني ومنتشر يبني جمهور وفي" },
    { prob: "المنصة تُستخدم كـ showcase لا كـ community", impact: "عالي", fix: "الرد على التعليقات بفيديو، Duet مع الزبائن، تفاعل حقيقي يبني مجتمع ولاء" },
  ];
  const igProblems = [
    { prob: "محتوى لا يوصل الشعور ولا يبيع اللحظة", impact: "عالي", fix: "الزبون يشتري الشعور قبل المنتج — صور الأكل على السفرة، العيلة تاكل، الوجه السعيد" },
    { prob: "غياب الشفات والمحتوى الموثوق", impact: "عالي", fix: "شيف أو شخص موثوق يعطي وصفة بمنتجات جيكور = دليل اجتماعي قوي جداً" },
    { prob: "الصفحة تفتقر للحياة والعفوية", impact: "عالي", fix: "40% محتوى تصميم + 60% محتوى عفوي قريب (مطبخ حقيقي، أشخاص حقيقيين)" },
    { prob: "عدم استخدام ريلز عفوي يوظف الترند بفعالية", impact: "عالي", fix: "ريلز بموسيقى ترند عراقي + محتوى قريب — ليس تصاميم جامدة أو ذكاء اصطناعي" },
    { prob: "6.3 منشورات/أسبوع بتفاعل 0.06% فقط", impact: "عالي", fix: "الحل ليس الكمية — الحل نوع المحتوى. قلّل وركز على الجودة والعفوية" },
    { prob: "محتوى UGC بدأ مؤخراً وأثبت نتائج ممتازة", impact: "فرصة", fix: "تسريع هذه الاستراتيجية وتوسيعها — هي الطريق الأقصر للوصول العضوي" },
  ];
  const ytProblems = [
    { prob: "القناة مهملة: 311 مشترك و 37 فيديو فقط", impact: "عالي", fix: "يوتيوب محتوى يبقى يُشاهَد لسنوات — كل فيديو وصفة = آلاف المشاهدات متراكمة" },
    { prob: "لا يوجد محتوى وصفات أو تعليمي منتظم", impact: "عالي", fix: "سلسلة أسبوعية: 'وصفة سريعة بمنتجات جيكور' — تبني سلطة وثقة في القطاع" },
    { prob: "غياب Shorts لجلب مشتركين جدد", impact: "متوسط", fix: "كل Reel إنستغرام أو تيك توك = Short يوتيوب جاهز بدون جهد إضافي" },
    { prob: "لا يوجد محتوى المصنع والجودة", impact: "عالي", fix: "فيديو 'يوم في مصنع جيكور' = أقوى محتوى لبناء الثقة مع الجمهور العراقي" },
    { prob: "39K مشاهدة على 37 فيديو = 1K متوسط/فيديو", impact: "متوسط", fix: "تحسين العناوين والـ Thumbnails + SEO عربي = مضاعفة المشاهدات بدون محتوى جديد" },
  ];

  const metricsMap = { tiktok: ttMetrics };
  const problemsMap = { tiktok: ttProblems, instagram: igProblems, youtube: ytProblems };
  const platColors = { instagram: C.ig, tiktok: C.tt, youtube: C.yt };

  return (
    <div dir="rtl" style={{ fontFamily: "'Cairo', 'Segoe UI', Arial, sans-serif", background: C.dark, minHeight: "100vh", color: "#f0f0f0", paddingBottom: 80 }}>

      {/* HEADER */}
      <div style={{ background: "linear-gradient(135deg, #0d1117 0%, #0f1923 60%, #0d1117 100%)", borderBottom: `2px solid ${C.red}`, padding: "28px 20px 20px", textAlign: "center", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", inset: 0, background: `radial-gradient(ellipse at 50% 0%, ${C.red}15 0%, transparent 70%)`, pointerEvents: "none" }} />
        <div style={{ fontSize: 10, color: C.red, letterSpacing: 4, marginBottom: 8 }}>تقرير تسويق متكامل — إعداد Ecomillin</div>
        <h1 style={{ margin: 0, fontSize: "clamp(22px, 5vw, 38px)", fontWeight: 900, lineHeight: 1.2, background: `linear-gradient(90deg, #fff, ${C.red}, ${C.gold})`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>شركة جيكور الغذائية</h1>
        <p style={{ color: "#8892b0", margin: "8px 0 16px", fontSize: 13 }}>تحليل شامل للسوشل ميديا + التطبيق + العرض التسويقي</p>
        <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
          {[
            { icon: "🎵", label: "تيك توك", val: "7.6K | 37.3M مشاهدة", color: C.tt },
            { icon: "📸", label: "إنستغرام", val: "55K | 0.06%", color: C.ig },
            { icon: "📺", label: "يوتيوب", val: "311 | 39K مشاهدة", color: C.yt },
            { icon: "🎰", label: "عجلة الحظ + سيارة", color: C.purple },
          ].map((b, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 5, background: `${b.color}15`, border: `1px solid ${b.color}40`, borderRadius: 20, padding: "4px 14px", fontSize: 11 }}>
              <span>{b.icon}</span><span style={{ color: b.color, fontWeight: 700 }}>{b.label}</span>
              {b.val && <span style={{ color: "#8892b0" }}>— {b.val}</span>}
            </div>
          ))}
        </div>
      </div>

      {/* TABS */}
      <div style={{ display: "flex", overflowX: "auto", background: "#050810", borderBottom: `1px solid ${C.border}`, padding: "0 10px" }}>
        {[
          { id: "competitor", label: "📊 تحليل المنافسين" },
          { id: "platforms", label: "📱 تحليل المنصات" },
          { id: "psychology", label: "🧠 السايكولوجية" },
          { id: "gamification", label: "🎮 الألعاب والمكافآت" },
          { id: "funnel", label: "🔄 رحلة الزبون" },
          { id: "offer", label: "💰 العرض" },
        ].map(tab => (
          <button key={tab.id} onClick={() => setActiveTab(tab.id)} style={{ padding: "14px 16px", background: "none", border: "none", color: activeTab === tab.id ? C.red : "#8892b0", borderBottom: activeTab === tab.id ? `2px solid ${C.red}` : "2px solid transparent", cursor: "pointer", whiteSpace: "nowrap", fontSize: 12, fontFamily: "inherit", fontWeight: activeTab === tab.id ? 700 : 400 }}>{tab.label}</button>
        ))}
      </div>

      <div style={{ maxWidth: 940, margin: "0 auto", padding: "24px 14px" }}>

        {/* ===== COMPETITOR ===== */}
        {activeTab === "competitor" && (
          <div>
            <SH title="تحليل المنافسين — جيكور vs سما كربلاء" subtitle="أرقام حقيقية تكشف أين أنتم وأين الفرصة الذهبية" />

            {/* KEY INSIGHT */}
            <div style={{ background: `${C.gold}10`, border: `1px solid ${C.gold}30`, borderRadius: 14, padding: "16px 20px", marginBottom: 22 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: C.gold, marginBottom: 8 }}>⚡ الاكتشاف الأهم في هذا التحليل:</div>
              <p style={{ margin: 0, color: "#ccd6f6", fontSize: 13, lineHeight: 1.9 }}>
                جيكور لديها <strong style={{ color: C.teal }}>37.3M مشاهدة</strong> مقابل <strong style={{ color: "#FF6B6B" }}>25.5M لسما</strong> — أي محتواكم <strong style={{ color: C.gold }}>يُشاهَد أكثر</strong>.
                ومتوسط مشاهدة الفيديو الواحد عندكم <strong style={{ color: C.teal }}>400.7K</strong> مقابل <strong style={{ color: "#FF6B6B" }}>130.8K</strong> فقط للمنافس.
                المشكلة ليست في المشاهدة — المشكلة في تحويل هذه المشاهدة إلى <strong style={{ color: C.gold }}>تفاعل وشراء</strong>.
              </p>
            </div>

            {/* TIKTOK STATS */}
            <h3 style={{ color: C.tt, fontSize: 12, letterSpacing: 2, marginBottom: 12 }}>🎵 تيك توك — المقارنة الكاملة</h3>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 22 }}>
              {[
                {
                  name: "جيكور", icon: "🏭", color: C.teal,
                  stats: [
                    { label: "المتابعون", val: "7.6K", note: "أقل من إمكاناتها", highlight: false },
                    { label: "إجمالي المشاهدات", val: "37.3M", note: "🔥 أعلى من سما!", highlight: true },
                    { label: "Engagement Rate", val: "0.2%", note: "أقل من المعيار 1%+", highlight: false },
                    { label: "متوسط مشاهدة/فيديو", val: "400.7K", note: "🔥 3x أعلى من سما!", highlight: true },
                  ],
                },
                {
                  name: "سما كربلاء", icon: "⚔️", color: "#FF6B6B",
                  stats: [
                    { label: "المتابعون", val: "26.5K", note: "أكثر متابعين", highlight: false },
                    { label: "إجمالي المشاهدات", val: "25.5M", note: "أقل رغم أكثر متابعين", highlight: false },
                    { label: "Engagement Rate", val: "1.2%", note: "6x أعلى من جيكور", highlight: true },
                    { label: "متوسط مشاهدة/فيديو", val: "130.8K", note: "أقل بكثير من جيكور", highlight: false },
                  ],
                },
              ].map((brand, bi) => (
                <div key={bi} style={{ background: `${brand.color}08`, border: `1px solid ${brand.color}30`, borderRadius: 14, padding: 16 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
                    <span style={{ fontSize: 20 }}>{brand.icon}</span>
                    <span style={{ fontWeight: 900, color: brand.color, fontSize: 14 }}>{brand.name}</span>
                  </div>
                  <div style={{ display: "grid", gap: 8 }}>
                    {brand.stats.map((s, si) => (
                      <div key={si} style={{ background: s.highlight ? `${brand.color}15` : "rgba(0,0,0,0.2)", border: s.highlight ? `1px solid ${brand.color}35` : "1px solid transparent", borderRadius: 10, padding: "9px 12px" }}>
                        <div style={{ fontSize: 10, color: "#8892b0", marginBottom: 3 }}>{s.label}</div>
                        <div style={{ fontSize: 17, fontWeight: 900, color: s.highlight ? brand.color : "#ccd6f6", marginBottom: 3 }}>{s.val}</div>
                        <div style={{ fontSize: 10, color: s.highlight ? brand.color : "#666" }}>{s.note}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* GROWTH CHART */}
            <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: 20, marginBottom: 22 }}>
              <div style={{ fontWeight: 800, color: "#fff", fontSize: 14, marginBottom: 4 }}>📈 منحنى النمو — آخر 90 يوم (تيك توك)</div>
              <div style={{ fontSize: 12, color: "#8892b0", marginBottom: 16 }}>القفزة المفاجئة لجيكور بعد تبني استراتيجية UGC — بينما سما في تراجع مستمر</div>
              <GrowthChart />
              <div style={{ marginTop: 14, background: `${C.teal}08`, border: `1px solid ${C.teal}20`, borderRadius: 10, padding: "10px 14px" }}>
                <span style={{ fontSize: 11, color: C.teal, fontWeight: 700 }}>💡 الدرس: </span>
                <span style={{ fontSize: 12, color: "#ccd6f6" }}>استراتيجية UGC التي بدأتها جيكور مؤخراً أنتجت قفزة درامية في النمو — في نفس الوقت الذي تتراجع فيه سما. هذا يؤكد أن التوجه صحيح ويجب تسريعه وتوسيعه فوراً.</span>
              </div>
            </div>

            {/* DEMOGRAPHICS */}
            <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: 20, marginBottom: 22 }}>
              <div style={{ fontWeight: 800, color: "#fff", fontSize: 14, marginBottom: 4 }}>👥 تحليل الجمهور — الأعمار والجنس</div>
              <div style={{ fontSize: 12, color: "#8892b0", marginBottom: 16 }}>فهم من يشاهد المحتوى = تصميم محتوى يستهدفه بدقة</div>
              <DemographicsChart />
              <div style={{ marginTop: 14, display: "grid", gap: 9 }}>
                {[
                  { icon: "🎯", text: "الفئة العمرية 20-29 هي الأكبر لجيكور (46%) — جيل الشباب العامل يبحث عن وجبات سريعة وسهلة التحضير", color: C.teal },
                  { icon: "👨", text: "67% ذكور في جيكور مقابل 87% في سما — فرصة لاستهداف ربات البيوت (النساء) بمحتوى مختلف وتوسيع القاعدة", color: C.gold },
                  { icon: "📊", text: "الفئة 20-39 مجتمعة = 76% من الجمهور — هذا هو الجمهور المستهدف الأساسي لكل حملة إعلانية", color: C.purple },
                ].map((item, i) => (
                  <div key={i} style={{ display: "flex", gap: 10, fontSize: 12, color: "#ccd6f6", background: `${item.color}08`, borderRadius: 9, padding: "9px 13px", borderRight: `3px solid ${item.color}` }}>
                    <span>{item.icon}</span><span>{item.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* YOUTUBE STATS */}
            <div style={{ background: `${C.yt}08`, border: `1px solid ${C.yt}25`, borderRadius: 14, padding: 18, marginBottom: 22 }}>
              <div style={{ fontWeight: 800, color: C.yt, fontSize: 14, marginBottom: 12 }}>📺 يوتيوب — الفرصة الضائعة</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10, marginBottom: 12 }}>
                {[{ label: "المشتركون", val: "311" }, { label: "إجمالي المشاهدات", val: "39,057" }, { label: "عدد الفيديوهات", val: "37" }].map((s, i) => (
                  <div key={i} style={{ background: "rgba(0,0,0,0.25)", borderRadius: 10, padding: 12, textAlign: "center" }}>
                    <div style={{ fontSize: 10, color: "#8892b0", marginBottom: 4 }}>{s.label}</div>
                    <div style={{ fontSize: 20, fontWeight: 900, color: C.yt }}>{s.val}</div>
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 12, color: "#ccd6f6", background: "rgba(0,0,0,0.2)", borderRadius: 9, padding: "10px 13px" }}>
                ⚠️ متوسط مشاهدة الفيديو الواحد = <strong style={{ color: C.yt }}>1,055 مشاهدة</strong> — هذا الرقم يمكن مضاعفته 10x بـ SEO صحيح وعناوين مدروسة وجدول نشر منتظم. لا جيكور ولا سما يستثمران يوتيوب — من يدخلها أولاً يكسب السوق.
              </div>
            </div>

            {/* INSTAGRAM COMPARISON */}
            <div style={{ background: `${C.ig}08`, border: `1px solid ${C.ig}25`, borderRadius: 14, padding: 18, marginBottom: 22 }}>
              <div style={{ fontWeight: 800, color: C.ig, fontSize: 14, marginBottom: 14 }}>📸 إنستغرام — المقارنة المباشرة</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
                {[
                  { name: "جيكور", followers: "55K", eng: "0.06%", posts: "6.30", engColor: "#ff6b6b", followColor: C.teal },
                  { name: "سما كربلاء", followers: "45K", eng: "0.14%", posts: "4.20", engColor: C.green, followColor: "#FF6B6B" },
                ].map((b, i) => (
                  <div key={i} style={{ background: "rgba(0,0,0,0.25)", borderRadius: 12, padding: 14 }}>
                    <div style={{ fontWeight: 800, color: i === 0 ? C.teal : "#FF6B6B", fontSize: 13, marginBottom: 12 }}>{i === 0 ? "🏭" : "⚔️"} {b.name}</div>
                    {[
                      { label: "المتابعون", val: b.followers, color: b.followColor },
                      { label: "Engagement Rate", val: b.eng, color: b.engColor },
                      { label: "منشورات/أسبوع", val: b.posts, color: "#8892b0" },
                    ].map((s, j) => (
                      <div key={j} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, background: "rgba(255,255,255,0.04)", borderRadius: 8, padding: "7px 11px" }}>
                        <span style={{ fontSize: 11, color: "#8892b0" }}>{s.label}</span>
                        <span style={{ fontSize: 14, fontWeight: 900, color: s.color }}>{s.val}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div style={{ display: "grid", gap: 8 }}>
                {[
                  { icon: "⚠️", text: "جيكور تنشر أكثر (6.3 مقابل 4.2 منشور/أسبوع) لكن تحصل على تفاعل أقل — الكمية لا تعوّض جودة المحتوى وملاءمته للجمهور", color: "#ff6b6b" },
                  { icon: "🎯", text: "سما تمتلك 10K متابع أقل لكن تحقق ضعفي الـ Engagement — لأن محتواها أقرب للجمهور وأكثر عفوية", color: C.gold },
                  { icon: "🚀", text: "الفجوة قابلة للإغلاق سريعاً: محتوى عفوي + UGC + ريلز ترند = مضاعفة الـ Engagement خلال 60 يوم", color: C.green },
                ].map((item, i) => (
                  <div key={i} style={{ display: "flex", gap: 9, fontSize: 12, color: "#ccd6f6", background: `${item.color}08`, borderRadius: 9, padding: "9px 13px", borderRight: `3px solid ${item.color}` }}>
                    <span>{item.icon}</span><span>{item.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* OPPORTUNITIES */}
            <h3 style={{ color: C.red, fontSize: 12, letterSpacing: 2, marginBottom: 12 }}>🎯 الفرص التنافسية المباشرة</h3>
            <div style={{ display: "grid", gap: 10 }}>
              {[
                { opp: "مشاهدات تيك توك أعلى — لكن التحويل ضعيف", desc: "37.3M مشاهدة تذهب بدون شراء — ربط كل فيديو بـ CTA واضح للتطبيق يضاعف التحميلات", color: C.tt },
                { opp: "UGC بدأ يعمل — ضاعفه الآن", desc: "القفزة في منحنى النمو واضحة بعد UGC — هذا ليس صدفة بل نتيجة استراتيجية صحيحة يجب تسريعها", color: C.teal },
                { opp: "يوتيوب — أرض خالية من المنافسة", desc: "311 مشترك فقط لكنها منصة SEO قوية — قناة وصفات أسبوعية تبني سلطة لا يستطيع المنافس اللحاق بها", color: C.yt },
                { opp: "عجلة الحظ والسيارة — ميزة لا يملكها المنافس", desc: "سما ليس عندها تطبيق ولا جوائز — هذا التمايز يجب أن يكون حاضراً في كل منشور كل يوم", color: C.purple },
              ].map((item, i) => (
                <div key={i} style={{ background: `${item.color}08`, border: `1px solid ${item.color}30`, borderRadius: 12, padding: "13px 17px", borderRight: `4px solid ${item.color}` }}>
                  <div style={{ fontWeight: 700, color: item.color, fontSize: 13, marginBottom: 4 }}>✅ {item.opp}</div>
                  <div style={{ fontSize: 12, color: "#8892b0" }}>{item.desc}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ===== PLATFORMS ===== */}
        {activeTab === "platforms" && (
          <div>
            <SH title="تحليل المنصات التفصيلي" subtitle="المحتوى مربوط بنتائج — نفهم ما يعمل ونستبعد ما لا يعمل وندور في حلقة تحسين مستمرة" />
            <div style={{ background: `${C.gold}10`, border: `1px solid ${C.gold}30`, borderRadius: 12, padding: "14px 18px", marginBottom: 20 }}>
              <p style={{ margin: 0, fontSize: 13, color: "#ccd6f6", lineHeight: 1.9 }}>
                <strong style={{ color: C.gold }}>🔑 مبدأ أساسي:</strong> النشر يجب أن يكون مرتبطاً بتحليل مستمر — نفهم ما يحبه الجمهور، نستبعد ما لا يعمل، نطور ما ينجح، ونجرب محتوى جديد باستمرار. <strong style={{ color: "#fff" }}>ليس task box</strong> نضرب فيه تيك ✓ ونكمل.
              </p>
            </div>
            <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" }}>
              {[{ id: "tiktok", label: "🎵 تيك توك", color: C.tt }, { id: "instagram", label: "📸 إنستغرام", color: C.ig }, { id: "youtube", label: "📺 يوتيوب", color: C.yt }].map(p => (
                <button key={p.id} onClick={() => { setActivePlatform(p.id); setExpandedProb(null); }} style={{ padding: "9px 18px", borderRadius: 22, border: `2px solid ${p.color}`, background: activePlatform === p.id ? p.color : "transparent", color: "#fff", cursor: "pointer", fontFamily: "inherit", fontWeight: 700, fontSize: 12 }}>{p.label}</button>
              ))}
            </div>

            {/* TikTok quick stats */}
            {activePlatform === "tiktok" && (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 8, marginBottom: 16 }}>
                {[
                  { label: "المتابعون", val: "7.6K", color: C.tt },
                  { label: "إجمالي المشاهدات", val: "37.3M 🔥", color: C.gold },
                  { label: "Engagement Rate", val: "0.2%", color: "#ff6b6b" },
                  { label: "متوسط مشاهدة/فيديو", val: "400.7K 🔥", color: C.gold },
                ].map((s, i) => (
                  <div key={i} style={{ background: `${s.color}08`, border: `1px solid ${s.color}25`, borderRadius: 11, padding: 12, textAlign: "center" }}>
                    <div style={{ fontSize: 10, color: "#8892b0", marginBottom: 4 }}>{s.label}</div>
                    <div style={{ fontSize: 15, fontWeight: 900, color: s.color }}>{s.val}</div>
                  </div>
                ))}
              </div>
            )}

            {activePlatform === "instagram" && (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 8, marginBottom: 16 }}>
                {[
                  { label: "المتابعون", val: "55K", color: C.ig },
                  { label: "Engagement Rate", val: "0.06%", color: "#ff6b6b" },
                  { label: "منشورات/أسبوع", val: "6.3", color: C.gold },
                  { label: "المعيار الطبيعي", val: "1%-3%", color: C.green },
                ].map((s, i) => (
                  <div key={i} style={{ background: `${s.color}08`, border: `1px solid ${s.color}25`, borderRadius: 11, padding: 12, textAlign: "center" }}>
                    <div style={{ fontSize: 10, color: "#8892b0", marginBottom: 4 }}>{s.label}</div>
                    <div style={{ fontSize: 15, fontWeight: 900, color: s.color }}>{s.val}</div>
                  </div>
                ))}
              </div>
            )}

            {activePlatform === "youtube" && (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 8, marginBottom: 16 }}>
                {[
                  { label: "المشتركون", val: "311", color: C.yt },
                  { label: "إجمالي المشاهدات", val: "39,057", color: C.gold },
                  { label: "عدد الفيديوهات", val: "37", color: "#8892b0" },
                  { label: "متوسط/فيديو", val: "~1K", color: "#ff6b6b" },
                ].map((s, i) => (
                  <div key={i} style={{ background: `${s.color}08`, border: `1px solid ${s.color}25`, borderRadius: 11, padding: 12, textAlign: "center" }}>
                    <div style={{ fontSize: 10, color: "#8892b0", marginBottom: 4 }}>{s.label}</div>
                    <div style={{ fontSize: 15, fontWeight: 900, color: s.color }}>{s.val}</div>
                  </div>
                ))}
              </div>
            )}

            <div style={{ display: "grid", gap: 8 }}>
              {(problemsMap[activePlatform] || []).map((item, i) => (
                <div key={i} onClick={() => setExpandedProb(expandedProb === i ? null : i)} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: "12px 15px", cursor: "pointer", borderRight: `3px solid ${item.impact === "عالي" ? "#ff6b6b" : item.impact === "فرصة" ? C.green : C.gold}` }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
                      <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: item.impact === "عالي" ? "rgba(255,107,107,0.12)" : item.impact === "فرصة" ? `${C.green}18` : `${C.gold}18`, color: item.impact === "عالي" ? "#ff6b6b" : item.impact === "فرصة" ? C.green : C.gold }}>
                        {item.impact === "عالي" ? "🔴" : item.impact === "فرصة" ? "🟢" : "🟡"} {item.impact}
                      </span>
                      <span style={{ fontSize: 13, color: "#ccd6f6" }}>{item.prob}</span>
                    </div>
                    <span style={{ color: "#8892b0", fontSize: 10 }}>{expandedProb === i ? "▲" : "▼"}</span>
                  </div>
                  {expandedProb === i && (
                    <div style={{ marginTop: 9, padding: "9px 12px", background: `${C.teal}08`, borderRadius: 8, border: `1px solid ${C.teal}20` }}>
                      <span style={{ fontSize: 11, color: C.teal }}>✅ الحل: </span><span style={{ fontSize: 12, color: "#e0e0e0" }}>{item.fix}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ===== PSYCHOLOGY ===== */}
        {activeTab === "psychology" && (
          <div>
            <SH title="سايكولوجية المستهلك العراقي" subtitle="كل منشور يجب أن يضرب على وتر نفسي محدد — فهم العقل قبل صياغة المحتوى" />
            <div style={{ display: "grid", gap: 12 }}>
              {psychologyLayers.map((item, i) => (
                <div key={i} onClick={() => setExpandedPsycho(expandedPsycho === i ? null : i)} style={{ background: C.card, border: `1px solid ${item.color}30`, borderRadius: 13, padding: "14px 18px", borderRight: `4px solid ${item.color}`, cursor: "pointer" }}>
                  <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                    <span style={{ fontSize: 22 }}>{item.icon}</span>
                    <div style={{ flex: 1 }}><div style={{ fontWeight: 800, fontSize: 14, color: "#fff" }}>{item.title}</div><div style={{ fontSize: 12, color: "#8892b0" }}>{item.desc}</div></div>
                    <span style={{ color: "#8892b0", fontSize: 10 }}>{expandedPsycho === i ? "▲" : "▼"}</span>
                  </div>
                  {expandedPsycho === i && (
                    <div style={{ marginTop: 12, display: "grid", gap: 8 }}>
                      <div style={{ background: "rgba(0,0,0,0.3)", borderRadius: 8, padding: "9px 13px" }}>
                        <div style={{ fontSize: 10, color: C.gold, marginBottom: 3 }}>💬 ما يدور في ذهن الزبون:</div>
                        <div style={{ fontSize: 13, color: "#ccd6f6", fontStyle: "italic" }}>"{item.trigger}"</div>
                      </div>
                      <div style={{ background: `${item.color}10`, borderRadius: 8, padding: "9px 13px", border: `1px solid ${item.color}25` }}>
                        <div style={{ fontSize: 10, color: item.color, marginBottom: 3 }}>✅ استراتيجية المحتوى:</div>
                        <div style={{ fontSize: 13, color: "#e0e0e0" }}>{item.solution}</div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ===== GAMIFICATION ===== */}
        {activeTab === "gamification" && (
          <div>
            <SH title="استراتيجية الألعاب والمكافآت" subtitle="ميزات تنافسية حصرية لا يملكها سما كربلاء — يجب أن تكون في كل منشور" />
            <div style={{ display: "flex", gap: 10, marginBottom: 22, flexWrap: "wrap" }}>
              {gamificationFeatures.map(f => (
                <button key={f.id} onClick={() => { setActiveFeature(f.id); setActivePlatformTactic(0); }} style={{ padding: "11px 18px", borderRadius: 12, border: `2px solid ${f.color}`, background: activeFeature === f.id ? f.gradient : "transparent", color: "#fff", cursor: "pointer", fontFamily: "inherit", fontWeight: 700, fontSize: 13, boxShadow: activeFeature === f.id ? `0 0 18px ${f.color}35` : "none" }}>{f.icon} {f.title}</button>
              ))}
            </div>
            {currentFeature && <>
              <div style={{ background: `${currentFeature.color}10`, border: `1px solid ${currentFeature.color}35`, borderRadius: 16, padding: 22, marginBottom: 18 }}>
                <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                  <div style={{ fontSize: 42 }}>{currentFeature.icon}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6, flexWrap: "wrap" }}>
                      <h2 style={{ margin: 0, color: "#fff", fontSize: 18, fontWeight: 900 }}>{currentFeature.title}</h2>
                      <span style={{ background: currentFeature.gradient, color: "#fff", borderRadius: 20, padding: "2px 10px", fontSize: 10 }}>{currentFeature.subtitle}</span>
                    </div>
                    <div style={{ display: "inline-block", background: `${currentFeature.color}18`, border: `1px solid ${currentFeature.color}35`, borderRadius: 8, padding: "5px 12px", marginBottom: 10 }}>
                      <span style={{ fontSize: 11, color: currentFeature.color }}>🧠 المحرك النفسي: </span>
                      <span style={{ fontSize: 12, color: "#ccd6f6", fontWeight: 700 }}>{currentFeature.psycho}</span>
                    </div>
                    <p style={{ margin: 0, fontSize: 13, color: "#8892b0", lineHeight: 1.8 }}>{currentFeature.psychoDetail}</p>
                  </div>
                </div>
              </div>
              <h3 style={{ color: currentFeature.color, fontSize: 12, letterSpacing: 2, marginBottom: 12 }}>📱 تكتيكات كل منصة</h3>
              <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
                {currentFeature.platforms.map((p, i) => (
                  <button key={i} onClick={() => setActivePlatformTactic(i)} style={{ padding: "7px 14px", borderRadius: 20, border: `1px solid ${activePlatformTactic === i ? currentFeature.color : C.border}`, background: activePlatformTactic === i ? `${currentFeature.color}18` : "transparent", color: activePlatformTactic === i ? currentFeature.color : "#8892b0", cursor: "pointer", fontFamily: "inherit", fontSize: 12 }}>{p.name}</button>
                ))}
              </div>
              <div style={{ display: "grid", gap: 9, marginBottom: 20 }}>
                {currentFeature.platforms[activePlatformTactic]?.tactics.map((tactic, i) => (
                  <div key={i} style={{ display: "flex", gap: 12, background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: "11px 15px", borderRight: `3px solid ${currentFeature.color}` }}>
                    <div style={{ minWidth: 22, height: 22, background: `${currentFeature.color}28`, borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 900, color: currentFeature.color, flexShrink: 0 }}>{i + 1}</div>
                    <div style={{ fontSize: 13, color: "#ccd6f6", lineHeight: 1.7 }}>{tactic}</div>
                  </div>
                ))}
              </div>
              <div style={{ background: "rgba(255,107,107,0.07)", border: "1px solid rgba(255,107,107,0.2)", borderRadius: 14, padding: 16 }}>
                <h3 style={{ color: "#ff6b6b", margin: "0 0 12px", fontSize: 12, letterSpacing: 2 }}>⚠️ أكثر الأخطاء الشائعة</h3>
                <div style={{ display: "grid", gap: 9 }}>
                  {currentFeature.mistakes.map((item, i) => (
                    <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 9, background: "rgba(0,0,0,0.2)", borderRadius: 10, padding: "11px 13px" }}>
                      <div><div style={{ fontSize: 10, color: "#ff6b6b", marginBottom: 3 }}>❌ الخطأ:</div><div style={{ fontSize: 12, color: "#ccd6f6" }}>{item.m}</div></div>
                      <div><div style={{ fontSize: 10, color: C.green, marginBottom: 3 }}>✅ الحل:</div><div style={{ fontSize: 12, color: "#e0e0e0" }}>{item.fix}</div></div>
                    </div>
                  ))}
                </div>
              </div>
            </>}
          </div>
        )}

        {/* ===== FUNNEL ===== */}
        {activeTab === "funnel" && (
          <div>
            <SH title="رحلة الزبون — من المنصة للتطبيق للشراء" subtitle="كل محتوى له هدف واحد: تحميل التطبيق والشراء" />
            <div style={{ background: `${C.teal}06`, border: `1px solid ${C.teal}20`, borderRadius: 14, padding: 16, marginBottom: 22 }}>
              <p style={{ margin: 0, fontSize: 13, color: "#ccd6f6", lineHeight: 1.9 }}>
                <strong style={{ color: C.teal }}>💡 المبدأ:</strong> السوشل ميديا = <strong style={{ color: C.gold }}>نقطة الاكتشاف</strong>. التطبيق = <strong style={{ color: C.gold }}>المحوّل الحقيقي</strong>. عجلة الحظ والسيارة وعرض 3+1 = <strong style={{ color: C.gold }}>الطعم الذي يجذب للتطبيق</strong>.
              </p>
            </div>
            <div style={{ marginBottom: 26 }}>
              {funnelSteps.map((step, i) => (
                <div key={i} style={{ display: "flex", gap: 12, marginBottom: 10 }}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div style={{ width: 42, height: 42, borderRadius: 11, background: `${step.color}20`, border: `2px solid ${step.color}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 900, color: step.color, flexShrink: 0 }}>{step.step}</div>
                    {i < funnelSteps.length - 1 && <div style={{ width: 2, flex: 1, minHeight: 14, background: `${step.color}25`, margin: "3px 0" }} />}
                  </div>
                  <div style={{ flex: 1, background: `${step.color}06`, border: `1px solid ${step.color}20`, borderRadius: 11, padding: "11px 15px", marginBottom: 2 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 7 }}>
                      <div><div style={{ fontWeight: 800, color: step.color, fontSize: 12, marginBottom: 3 }}>{step.label}</div><div style={{ fontSize: 13, color: "#ccd6f6" }}>{step.action}</div></div>
                      <div style={{ background: `${step.color}15`, border: `1px solid ${step.color}30`, borderRadius: 20, padding: "3px 10px", fontSize: 10, color: step.color, whiteSpace: "nowrap" }}>{step.channel}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <h3 style={{ color: C.red, fontSize: 12, letterSpacing: 2, marginBottom: 12 }}>🔗 دور كل منصة في دفع الزبون للتطبيق</h3>
            <div style={{ display: "grid", gap: 9 }}>
              {[
                { platform: "إنستغرام 📸", role: "الإلهام والشهية", cta: "رابط في Bio + Story → صفحة التطبيق", kpi: "Link Clicks + تحميلات", color: C.ig },
                { platform: "تيك توك 🎵", role: "الانتشار الفيروسي", cta: "رابط في Bio + Comment المثبّت", kpi: "مشاهدات + تحميلات", color: C.tt },
                { platform: "يوتيوب 📺", role: "الثقة والقرار النهائي", cta: "Card Links + Description + Shorts", kpi: "Watch Time + تحميلات", color: C.yt },
              ].map((item, i) => (
                <div key={i} style={{ background: C.card, border: `1px solid ${item.color}25`, borderRadius: 12, padding: "13px 16px", borderRight: `4px solid ${item.color}` }}>
                  <div style={{ display: "grid", gridTemplateColumns: "110px 1fr 1fr 1fr", gap: 12, alignItems: "start" }}>
                    <div style={{ fontWeight: 800, color: item.color, fontSize: 13 }}>{item.platform}</div>
                    <div><div style={{ fontSize: 10, color: "#8892b0", marginBottom: 2 }}>الدور</div><div style={{ fontSize: 12, color: "#ccd6f6" }}>{item.role}</div></div>
                    <div><div style={{ fontSize: 10, color: "#8892b0", marginBottom: 2 }}>CTA</div><div style={{ fontSize: 11, color: "#e0e0e0" }}>{item.cta}</div></div>
                    <div><div style={{ fontSize: 10, color: "#8892b0", marginBottom: 2 }}>KPI</div><div style={{ fontSize: 11, color: item.color }}>{item.kpi}</div></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ===== OFFER ===== */}
        {activeTab === "offer" && (
          <div>

            {/* OPENING HOOK */}
            <div style={{ background: "linear-gradient(135deg, rgba(233,69,96,0.13), rgba(15,32,60,0.4))", border: `1px solid ${C.red}40`, borderRadius: 16, padding: "22px 24px", marginBottom: 24, textAlign: "center" }}>
              <div style={{ fontSize: 11, color: C.red, letterSpacing: 4, marginBottom: 10 }}>العرض الحصري — Ecomillin</div>
              <h2 style={{ margin: "0 0 14px", fontSize: "clamp(18px, 3.5vw, 26px)", fontWeight: 900, color: "#fff", lineHeight: 1.5 }}>
                رأيتم اليوم أن 37.3M مشاهدة<br />
                <span style={{ background: `linear-gradient(90deg, ${C.gold}, ${C.red})`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>لا تتحول لتفاعل ولا لتحميلات.</span>
              </h2>
              <p style={{ color: "#8892b0", fontSize: 13, lineHeight: 1.9, maxWidth: 540, margin: "0 auto" }}>
                هذا العرض يغلق تلك الفجوة — بخطة مبنية على بياناتكم الحقيقية، لا على قوالب جاهزة تصلح للجميع.
              </p>
            </div>

            {/* URGENCY BANNER */}
            <div style={{ background: `${C.purple}10`, border: `1px solid ${C.purple}35`, borderRadius: 12, padding: "13px 18px", marginBottom: 22, display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ fontSize: 22, flexShrink: 0 }}>⚡</div>
              <div>
                <div style={{ fontWeight: 800, color: C.purple, fontSize: 13, marginBottom: 3 }}>عرض محدود لعميل واحد في قطاع الغذاء العراقي</div>
                <div style={{ fontSize: 12, color: "#8892b0" }}>لا نعمل مع منافسيكم المباشرين — بمجرد قبول هذا العرض، قطاعكم يصبح حصرياً لنا ولكم.</div>
              </div>
            </div>

            {/* WHAT THE ANALYSIS REVEALED */}
            <div style={{ background: "rgba(255,107,107,0.07)", border: "1px solid rgba(255,107,107,0.2)", borderRadius: 14, padding: "16px 20px", marginBottom: 22 }}>
              <div style={{ fontWeight: 800, color: "#ff6b6b", marginBottom: 12, fontSize: 13 }}>🔍 ما كشفه التحليل — وتكلفة التأخر:</div>
              <div style={{ display: "grid", gap: 8 }}>
                {[
                  { prob: "تيك توك: 37.3M مشاهدة لكن 0.2% engagement فقط", cost: "مشاهدة بدون تفاعل = وصول لا يُبنى عليه" },
                  { prob: "إنستغرام: 55K متابع لكن 0.06% engagement", cost: "جمهور كبير وصامت = ميزانية نشر بدون عائد" },
                  { prob: "يوتيوب: 311 مشترك فقط مقابل 39K مشاهدة", cost: "فرصة SEO ذهبية لا يستثمرها أي منافس حتى الآن" },
                  { prob: "التطبيق وعجلة الحظ والسيارة لا تُوظَّف بشكل كافٍ", cost: "ميزات تنافسية حقيقية تحتاج حضوراً أقوى في كل منصة" },
                ].map((item, i) => (
                  <div key={i} style={{ background: "rgba(0,0,0,0.2)", borderRadius: 10, padding: "10px 14px" }}>
                    <div style={{ fontSize: 12, color: "#ccd6f6", marginBottom: 4 }}>● {item.prob}</div>
                    <div style={{ fontSize: 11, color: "#ff6b6b" }}>↳ {item.cost}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* 3-MONTH ROADMAP */}
            <h3 style={{ color: C.teal, fontSize: 12, letterSpacing: 2, marginBottom: 14 }}>🗓️ خارطة الطريق — 90 يوماً نرى فيها نتائج حقيقية</h3>
            <div style={{ display: "grid", gap: 10, marginBottom: 24 }}>
              {[
                {
                  month: "الشهر الأول", icon: "🏗️", color: C.ig,
                  goal: "بناء الأساس الصحيح",
                  actions: ["توظيف هوية بصرية محكمة وموحدة على كل المنصات", "خطة محتوى مبنية على تحليل الجمهور (20-29 سنة، 67% ذكور)", "تسريع وتوسيع استراتيجية UGC التي أثبتت نجاحها", "ربط أغلب المحتوى برابط التطبيق وعجلة الحظ"],
                  result: "ارتفاع ملحوظ في التفاعل وأول موجة تحميلات منظّمة للتطبيق",
                },
                {
                  month: "الشهر الثاني", icon: "🚀", color: C.tt,
                  goal: "تفعيل الجوائز والعروض",
                  actions: ["محتوى مخصص لعجلة الحظ والسيارة على كل منصة", "حملات App Install مدفوعة مستهدفة", "إطلاق تيك توك بمحتوى عفوي مخصص للمنصة", "تفعيل يوتيوب: وصفات + Shorts أسبوعية"],
                  result: "نمو قابل للقياس في تحميلات التطبيق وتفاعل حقيقي مع العروض",
                },
                {
                  month: "الشهر الثالث", icon: "📈", color: C.green,
                  goal: "تسريع النمو وقياس العائد",
                  actions: ["تحليل ما نجح وتضخيمه، استبعاد ما لم يعمل", "Re-targeting لمن زار التطبيق ولم يشترِ", "بناء مجتمع وفي حول جيكور على كل المنصات", "تقرير شامل بالنتائج ومقارنة بالبداية"],
                  result: "نمو مستدام + جمهور مفعّل + تطبيق يتحول لقناة تفاعل وتحميلات حقيقية",
                },
              ].map((phase, i) => (
                <div key={i} style={{ background: `${phase.color}08`, border: `1px solid ${phase.color}30`, borderRadius: 14, padding: "16px 18px", borderRight: `4px solid ${phase.color}` }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                    <span style={{ fontSize: 22 }}>{phase.icon}</span>
                    <div>
                      <div style={{ fontWeight: 900, color: phase.color, fontSize: 13 }}>{phase.month}</div>
                      <div style={{ fontSize: 12, color: "#fff", fontWeight: 700 }}>{phase.goal}</div>
                    </div>
                  </div>
                  <div style={{ display: "grid", gap: 5, marginBottom: 12 }}>
                    {phase.actions.map((a, j) => (
                      <div key={j} style={{ display: "flex", gap: 8, fontSize: 12, color: "#8892b0" }}>
                        <span style={{ color: phase.color, flexShrink: 0 }}>→</span>{a}
                      </div>
                    ))}
                  </div>
                  <div style={{ background: `${phase.color}15`, borderRadius: 8, padding: "8px 12px", border: `1px solid ${phase.color}30` }}>
                    <span style={{ fontSize: 10, color: phase.color, fontWeight: 700 }}>🎯 النتيجة المتوقعة: </span>
                    <span style={{ fontSize: 12, color: "#ccd6f6" }}>{phase.result}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* SERVICES */}
            <h3 style={{ color: C.teal, fontSize: 12, letterSpacing: 2, marginBottom: 14 }}>📦 ما يشمله العرض الشهري:</h3>
            <div style={{ display: "grid", gap: 10, marginBottom: 26 }}>
              {offerItems.map((item, i) => (
                <div key={i} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: "13px 17px", display: "flex", gap: 14, alignItems: "flex-start", borderRight: `3px solid ${C.teal}` }}>
                  <div style={{ fontSize: 24, flexShrink: 0 }}>{item.icon}</div>
                  <div>
                    <div style={{ fontWeight: 800, color: "#fff", fontSize: 13, marginBottom: 3 }}>{item.title}</div>
                    <div style={{ fontSize: 12, color: "#8892b0", lineHeight: 1.7 }}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* SOCIAL PROOF */}
            <div style={{ background: `${C.gold}08`, border: `1px solid ${C.gold}30`, borderRadius: 14, padding: "18px 20px", marginBottom: 22 }}>
              <div style={{ fontWeight: 800, color: C.gold, marginBottom: 14, fontSize: 13 }}>⭐ نتائج حقيقية — لا وعود</div>
              <div style={{ background: "rgba(0,0,0,0.25)", borderRadius: 12, padding: "16px 18px", borderRight: `4px solid ${C.gold}` }}>
                <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <div style={{ fontSize: 28, flexShrink: 0 }}>📈</div>
                  <div>
                    <div style={{ fontWeight: 800, color: "#fff", fontSize: 14, marginBottom: 6 }}>استراتيجية UGC — جيكور نفسها</div>
                    <div style={{ fontSize: 13, color: "#ccd6f6", lineHeight: 1.9 }}>
                      القفزة الدرامية التي رأيتموها في منحنى النمو على تيك توك — تلك الاستراتيجية هي من بنيناها وطبّقناها مع جيكور. النتيجة واضحة في البيانات: <strong style={{ color: C.gold }}>نمو حاد لجيكور في نفس الوقت الذي تتراجع فيه سما كربلاء</strong>. هذا ليس صدفة — هذا ما يحدث حين تُطبَّق الاستراتيجية الصحيحة.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* PRICE BOX */}
            <div style={{ background: "linear-gradient(135deg, rgba(233,69,96,0.15), rgba(245,166,35,0.1))", border: `2px solid ${C.gold}`, borderRadius: 20, padding: 30, textAlign: "center", marginBottom: 20 }}>
              <div style={{ fontSize: 13, color: "#8892b0", marginBottom: 6 }}>القيمة الإجمالية للحزمة</div>
              <div style={{ fontSize: 36, fontWeight: 900, color: "#444", textDecoration: "line-through", marginBottom: 6 }}>$4,000</div>
              <div style={{ fontSize: 11, color: C.gold, letterSpacing: 4, marginBottom: 10 }}>السعر الشهري الحصري</div>
              <div style={{ fontSize: "clamp(48px, 9vw, 72px)", fontWeight: 900, background: `linear-gradient(90deg, ${C.gold}, ${C.red})`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", lineHeight: 1 }}>$3,000</div>
              <div style={{ fontSize: 13, color: "#8892b0", marginTop: 8 }}>شهرياً — عقد مرن قابل للتجديد</div>
              <div style={{ marginTop: 16, display: "inline-flex", alignItems: "center", gap: 8, background: `${C.green}15`, border: `1px solid ${C.green}40`, borderRadius: 20, padding: "8px 22px" }}>
                <span style={{ color: C.green, fontWeight: 700, fontSize: 13 }}>✅ توفير $1,000 عن السعر الأصلي</span>
              </div>
            </div>

            {/* GUARANTEE */}
            <div style={{ background: "linear-gradient(135deg, rgba(52,211,153,0.12), rgba(52,211,153,0.04))", border: `2px solid ${C.green}`, borderRadius: 16, padding: "20px 22px", marginBottom: 20 }}>
              <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                <div style={{ fontSize: 36, flexShrink: 0 }}>🛡️</div>
                <div>
                  <div style={{ fontWeight: 900, color: C.green, fontSize: 15, marginBottom: 8 }}>ضمان النتائج — نتحمل المسؤولية معكم</div>
                  <p style={{ margin: 0, color: "#ccd6f6", fontSize: 13, lineHeight: 1.9 }}>
                    نحن نبني على استراتيجية أثبتت نجاحها معكم فعلاً. لذلك نحن واثقون بما نقدمه:{" "}
                    <strong style={{ color: C.green }}>إذا لم تتحسن مؤشرات الأداء بشكل ملحوظ خلال 60 يوماً، نعمل معكم الشهر الثالث مجاناً — بدون قيد أو شرط.</strong>
                  </p>
                  <div style={{ marginTop: 10, fontSize: 12, color: "#8892b0" }}>
                    هذا ليس كلاماً تسويقياً — هذه ثقة بالنتائج مبنية على تجربة حقيقية معكم.
                  </div>
                </div>
              </div>
            </div>

            {/* WHY US */}
            <div style={{ background: `${C.teal}06`, border: `1px solid ${C.teal}20`, borderRadius: 14, padding: "18px 20px" }}>
              <div style={{ fontWeight: 800, color: C.teal, marginBottom: 12, fontSize: 13 }}>🏆 لماذا Ecomillin وليس غيرنا؟</div>
              <div style={{ display: "grid", gap: 9 }}>
                {[
                  { icon: "📊", text: "نعمل على أساس بيانات حقيقية — هذا التقرير الذي بين أيديكم هو مثال على كيفية عملنا" },
                  { icon: "🎯", text: "نفهم سايكولوجية المستهلك العراقي — محتوى يضرب على الوتر الصحيح ويحرك قرار الشراء" },
                  { icon: "✅", text: "نتائجنا موجودة في بياناتكم — القفزة في منحنى النمو بعد UGC هي عملنا أنتم شهوده" },
                  { icon: "📈", text: "كل قرار مربوط بنتيجة قابلة للقياس — تقارير أسبوعية وشهرية تثبت العائد على الاستثمار" },
                ].map((item, i) => (
                  <div key={i} style={{ display: "flex", gap: 12, fontSize: 13, color: "#ccd6f6" }}>
                    <span style={{ fontSize: 16 }}>{item.icon}</span>{item.text}
                  </div>
                ))}
              </div>
            </div>

          </div>
        )}

      </div>
    </div>
  );
}

function SH({ title, subtitle }) {
  return (
    <div style={{ marginBottom: 22 }}>
      <h2 style={{ margin: "0 0 5px", fontSize: "clamp(16px, 3vw, 22px)", fontWeight: 900, color: "#fff" }}>{title}</h2>
      <p style={{ margin: 0, color: "#8892b0", fontSize: 12, lineHeight: 1.7 }}>{subtitle}</p>
      <div style={{ height: 3, width: 46, borderRadius: 2, marginTop: 11, background: `linear-gradient(90deg, ${C.red}, #0f3460)` }} />
    </div>
  );
}
